import * as React from 'react';
import styled from 'styled-components';
import { Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

interface ISBTitleProps {
  title: React.ReactNode;
}

const Title = styled.h1`
  font-family: ${Font.Family.SANS} !important;
  font-size: 28px;
  color: ${Colors.GRAY_DARK_20};
  font-weight: 300;
  margin-top: 0;

  @media (max-width: ${ScreenWidth.SMALL}) {
    margin-top: ${Spacing.SINGLE};
    margin-left: ${Spacing.SINGLE};
    margin-right: ${Spacing.SINGLE};
  }
`;

export const SubTitle = styled.p<{ full?: boolean; smallText?: boolean; error?: boolean }>`
  font-size: ${({ smallText }) => (smallText ? '12px' : '14px')};
  font-family: ${Font.Family.SANS};
  color: ${({ error }) => (error ? Colors.RADISH : Colors.GRAY_DARK_10)};
  width: ${({ full }) => (full ? '100%' : '50%')};

  @media (max-width: ${ScreenWidth.SMALL}) {
    width: 100%;
  }
`;

export const SBTitle: React.FC<ISBTitleProps> = (props) => {
  const { title } = props;

  return <Title>{title}</Title>;
};
